import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "./AuthContext";

const BillingContext = createContext({ ent: null, loading: true, refresh: () => {} });
export const useBilling = () => useContext(BillingContext);

export const BillingProvider = ({ children }) => {
  const { user } = useAuth();
  const [ent, setEnt] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) { setEnt(null); setLoading(false); return; }
    setLoading(true);
    try { const r = await api.get("/billing/status"); setEnt(r.data); }
    catch { setEnt({ premium: false, market: false, leads: false, tier: "free" }); }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return <BillingContext.Provider value={{ ent, loading, refresh }}>{children}</BillingContext.Provider>;
};
